module.exports = __webpack_public_path__ + "img/user.c5d049b7.svg";